import React from 'react';

import DropdownFilterForm, {prefixedToggleText} from 'search/filters/base/DropdownFilterForm';
import {FilterKey, GenericFilter} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

interface AccountStatusFilterFormProps extends BaseFilterFormProps {
  filter: GenericFilter<FilterKey.ACCOUNT_STATUS>;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: GenericFilter<FilterKey.ACCOUNT_STATUS>) => void;
  onRemove?: () => void;
}

export default function AccountStatusFilterForm(props: AccountStatusFilterFormProps): JSX.Element {
  const baseProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const optionDatas = [
    {
      name: 'Suspended',
      // Keep in sync with benchling/parties/users/user_search.py
      value: 'SUSPENDED',
    },
    {
      name: 'Active',
      // Keep in sync with benchling/parties/users/user_search.py
      value: 'ACTIVE',
    },
  ];

  return (
    // @ts-expect-error TODO(BNCH-56923): Fix this; this component was created treating `props.filter` as a
    // `MultiValueFilter`, but it is a `SingleValueFilter`, meaning `value` is not an array type.
    // Some possible solutions:
    // - Make this a single select dropdown and update the `onChangeValue` to assert there is 0 or 1 selected
    //   statuses (see `client/search/filters/SharedWithFilterForm.tsx` for an example)
    // - Change `ACCOUNT_STATUS` to be a `MultiValueFilter`
    <DropdownFilterForm
      {...baseProps}
      dropdownToggleText={prefixedToggleText('Account status', optionDatas, props.filter)}
      filterStyle={props.filterStyle}
      isMulti={true}
      isSearchable={false}
      onChangeValue={(value: Array<string>) => {
        // @ts-expect-error: See above
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={optionDatas}
      value={props.filter.value || []}
    />
  );
}
